let inputs

export function SearchInput(els, context) {
    inputs = Array.from(els).map((el) => {
        return {
            el,
            input: el.querySelector('input')
        }
    })

    setupInitialState(inputs)
    addEventListeners(inputs)

    context.addEventListener('click', (evt) => {
        if (evt.target.classList.contains('js-search-input-btn')) {
            clearInput(evt)
        }
    })
}

function clearInput(evt) {
    evt.preventDefault()
    const parent = evt.target.closest('.js-search-input')
    const input = parent.querySelector('input')
    input.value = ''
    handleChange(evt)
}

function setupInitialState(inputs) {
    inputs.forEach(({ el, input }) => {
        if (el.dataset.searchSetup) {
            return
        }

        if (!input.value) {
            el.removeAttribute('data-active')
        } else if (!el.dataset.active) {
            el.dataset.active = true
        }

        el.dataset.searchSetup = true
    })
}

function addEventListeners(inputs) {
    inputs.forEach(({ input }) => {
        input.addEventListener('input', handleChange)
    })
}

function handleChange(evt) {
    let target = evt.target.closest('.js-search-input')
    let input = target.querySelector('input')
    if (!target) return
    if (input.value) {
        target.dataset.active = true
    } else {
        target.removeAttribute('data-active')
    }
}
